import { render } from "./Messages.vue?vue&type=template&id=622a2746&scoped=true&lang=pug"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=622a2746&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622a2746"]])

export default __exports__